
export type ApiHealth = {
  status: string;
}

export const API_STATUS_OK = "UP"